/* eslint-disable camelcase */
import english from './english'
import german from './german'
import french from './french'
import italian from './italian'
import spanish from './spanish'
import de_DE from './pseudo-locale/de_DE'
import en_GB from './pseudo-locale/en_GB'
import en_IE from './pseudo-locale/en_IE'
import fr_FR from './pseudo-locale/fr_FR'
import sd_SD from './pseudo-locale/sd_SD'
import sd_IE from './pseudo-locale/sd_IE'
import as_AS from './pseudo-locale/as_AS'
import es_ES from './pseudo-locale/es_ES'
import it_IT from './pseudo-locale/it_IT'

export default {
  english,
  german,
  french,
  italian,
  spanish,
  de_DE,
  en_GB,
  en_IE,
  fr_FR,
  sd_SD,
  sd_IE,
  as_AS,
  it_IT,
  es_ES
}
